import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import BudgetExecution from "./components/BudgetExecution";
import UsageRanking from "./components/UsageRanking";
import LowConsumptionRatio from "./components/LowConsumptionRatio";
import ReceiveAndSend from "./components/ReceiveAndSend";
import DepartmentRequisition from "./components/DepartmentRequisition";
import RealTimeInventory from "./components/RealTimeInventory";
import TotalAssetChange from "./components/TotalAssetChange";
import AssetMapFloor from "@/components/AssetMapFloor";
import { Modal } from "antd";
import AssetMapPudong from "@/components/AssetMapPudong";
import AssetMapMinhang from "@/components/AssetMapMinhang";
import AssetMap from "@/components/AssetMap";
export default function LCG() {
    const [modal, contextHolder] = Modal.useModal();
    const [minhangVisible, setMinhangVisible] = useState(false);
    const [pudongVisible, setPudongVisible] = useState(false);
    const [floorVisible, setFloorVisible] = useState(false);
    const minhangRef = useRef(null);
    const pudongRef = useRef(null);
    const floorUrl = useRef("");
    const floorInfo = useRef({});
    function handleClick(params) {
        if (params == "闵行区") {
            setMinhangVisible(true);
        }
        else if (params == "浦东新区") {
            setPudongVisible(true);
        }
    }
    useEffect(() => {
        if (minhangVisible) {
            minhangRef.current?.renRenderLoop?.();
        }
        else {
            minhangRef.current?.stopRenderLoop?.();
        }
    }, [minhangVisible]);
    useEffect(() => {
        if (pudongVisible) {
            pudongRef.current?.renRenderLoop?.();
        }
        else {
            pudongRef.current?.stopRenderLoop?.();
        }
    }, [pudongVisible]);
    useEffect(() => {
        if (floorVisible) {
            minhangRef.current?.stopRenderLoop?.();
        }
        else {
            minhangRef.current?.renRenderLoop?.();
        }
    }, [floorVisible]);
    const onPointClick = (pointInfo) => {
        let { pointData } = pointInfo;
        if (pointData) {
            floorInfo.current = pointInfo;
            floorUrl.current = pointData;
            setFloorVisible(true);
        }
        else {
            modal.error({
                title: "加载楼层失败",
                content: "请检查JSON数据",
            });
        }
    };
    return (_jsx("div", { className: "flex-1 w-full p-[0.3rem] overflow-hidden min-h-0", children: _jsxs("div", { className: "flex gap-[0.1rem] h-full", children: [_jsxs("div", { className: "flex flex-col gap-[0.1rem]  w-[4.47rem] flex-shrink-0 ", children: [_jsx("div", { className: "flex-1 min-w-0 min-h-0", children: _jsx(BudgetExecution, { className: "w-full h-full" }) }), _jsx("div", { className: "flex-1 min-w-0 min-h-0", children: _jsx(UsageRanking, { className: "w-full h-full" }) }), _jsx("div", { className: "flex-1 min-w-0 min-h-0", children: _jsx(LowConsumptionRatio, { className: "w-full h-full" }) })] }), _jsxs("div", { className: "flex flex-col flex-1 min-w-0 min-h-0", children: [_jsxs("div", { className: "flex-[67.1%]  min-h-0 min-w-0 flex-shrink-1", children: [_jsx(AssetMap, { className: "w-full h-full min-w-0 min-h-0", url: "/uam/datav/screen/area/0", onClick: handleClick }), _jsx(Modal, { className: "fullscreen-modal", open: minhangVisible, onCancel: () => setMinhangVisible(false), width: "calc(100vw - 0px)", style: { top: 0, paddingBottom: 0 }, children: _jsx(AssetMapMinhang, { ref: minhangRef, onPointClick: onPointClick, type: 'lcg' }) }), _jsx(Modal, { className: "fullscreen-modal", open: pudongVisible, onCancel: () => setPudongVisible(false), width: "calc(100vw - 0px)", style: { top: 0, paddingBottom: 0 }, children: _jsx(AssetMapPudong, { ref: pudongRef, onPointClick: onPointClick, type: 'lcg' }) }), _jsx(Modal, { className: "fullscreen-modal", open: floorVisible, onCancel: () => setFloorVisible(false), width: "calc(100vw - 0px)", style: { top: 0, paddingBottom: 0 }, destroyOnHidden: true, children: _jsx(AssetMapFloor, { jsonUrl: floorUrl.current, floorInfo: floorInfo.current, type: 'lcg' }) }), _jsx("style", { children: `
                .fullscreen-modal {
                  margin: 0
                }
                .fullscreen-modal .h-full {
                  overflow: hidden;
                  width:100vw;
                }
                .fullscreen-modal canvas.h-full {
                  height: 100vh
                }
                .fullscreen-modal .ant-modal {
                  max-width: 100vw;
                  width: 100vw !important;
                  top: 0;
                  height: 100vh;
                  padding-bottom: 0;
                }
                .fullscreen-modal .ant-modal-content {
                  width: 100vw;
                  height: 100vh;
                  display: flex;
                  flex-direction: column;
                  padding: 0
                }
                .fullscreen-modal .ant-modal-body {
                  flex: 1;
                  overflow-y: auto;
                }
                .fullscreen-modal .ant-modal-footer {
                  display:none
                }
                .fullscreen-modal .ant-modal-close {
                  width: 40px;
                  height: 40px;
                  background: white;
                  border-radius: 50%;
                  color: black
                }
                ` })] }), _jsx("div", { className: "flex-[32.9%] min-h-0 min-w-0", children: _jsx(RealTimeInventory, { className: "w-full h-full" }) })] }), _jsxs("div", { className: "flex flex-col gap-[0.1rem] flex-shrink-0 w-[4.47rem]", children: [_jsx("div", { className: "flex-1 min-w-0 min-h-0", children: _jsx(TotalAssetChange, { className: "w-full h-full" }) }), _jsx("div", { className: "flex-1 min-w-0 min-h-0", children: _jsx(ReceiveAndSend, { className: "w-full h-full" }) }), _jsx("div", { className: "flex-1 min-w-0 min-h-0", children: _jsx(DepartmentRequisition, { className: "w-full h-full" }) })] })] }) }));
}
